//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/AnimationDesigner.js";
import "../AnimationDesigner/AnimationDesigner.MotorBuilder.js";
let d=[[[0,"AxisType",1,0],[0,"Color",1,0],[0,"ColorOption",1,0]],[[["index"],"CreateBar",{},1,0],[["bars"],"DeleteBars",{},1,0],[["bars","shift_time","isCut"],"PasteBars",{},3,0],[["bars","mirror_time"],"MirrorBars",{},2,0],[["index","split_time"],"SplitBar",{},2,0],[["index","name"],"SetBarName",{},2,0],[["index","start_time"],"SetBarStartTime",{},2,0],[["index","end_time"],"SetBarEndTime",{},2,0],[["index","calc_type"],"SetBarCalcType",{},2,0],[["index","speed"],"SetBarSpeed",{},2,0],[["index","increment"],"SetBarIncrement",{},2,0],[["index","limit_acceleration"],"SetBarLimitAcceleration",{},2,0],[["index","acceleration"],"SetBarAcceleration",{},2,0],[["index","deceleration"],"SetBarDeceleration",{},2,0],[["bars","deltaStart","deltaDuration"],"SetBarTime",{},3,0],[["index"],"BarCalculate",{},1,0],[[],"UpdateDestination",{},0,0]],[]];
SPLM.AnimationDesigner.PositionMotorBuilder = class extends SPLM.AnimationDesigner.MotorBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.AnimationDesigner.PositionMotorBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.AnimationDesigner.PositionMotorBuilder.Axis = Object.freeze({
    "Angular" : "Angular", "Linear" : "Linear", "Mixed" : "Mixed"});

SPLM.AnimationDesigner.PositionMotorBuilder.AutoCalculate = Object.freeze({
    "EndTime" : "EndTime", "Speed" : "Speed", "Destination" : "Destination"});

SPLM.AnimationDesigner.PositionMotorBuilder.ColorOptions = Object.freeze({
    "SpecifyColor" : "SpecifyColor", "NoColor" : "NoColor"});

export default SPLM;